import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_SESSION_CART_PICKUP_ADDRESS_REQUEST = "API_SESSION_CART_PICKUP_ADDRESS_REQUEST";
export const API_SESSION_CART_PICKUP_ADDRESS_SUCCESS = "API_SESSION_CART_PICKUP_ADDRESS_SUCCESS";
export const API_SESSION_CART_PICKUP_ADDRESS_FAILURE = "API_SESSION_CART_PICKUP_ADDRESS_FAILURE";

export const api_session_cart_pickup_address_request = (options) => {
	return {
		type: API_SESSION_CART_PICKUP_ADDRESS_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_session_cart_pickup_address_success = (data) => {
	return {
		type: API_SESSION_CART_PICKUP_ADDRESS_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_session_cart_pickup_address_failure = (error) => {
	return {
		type: API_SESSION_CART_PICKUP_ADDRESS_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Session.apiSessionCartPickupAddress
*/
export const apiSessionCartPickupAddress = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_session_cart_pickup_address_request(options));
			const url=getAPIUrl([
				{"url": "/api/session/cart/pickup/address", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_session_cart_pickup_address_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_session_cart_pickup_address_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
